<section class="mx-3">
  <app-toast></app-toast>
  <ng-container>
    <div class="">
      <div class="d-flex align-items-center">
        <div>
          <button class="back_icon me-2" (click)="NavigateToBack()">
            <i class="fa-solid fa-arrow-left"></i>
          </button>
        </div>
        <!-- <div>
          <button (click)="editdata({id:35745})">edit</button>
        </div> -->
        <ng-container *ngIf="!editingEmployeeId">
          <h4 translate class="m-0">Add Employee</h4>
        </ng-container>
        <ng-container *ngIf="editingEmployeeId">
          <h4 translate class="m-0">Edit Employee</h4>
        </ng-container>
      </div>

      <div class="wrapper">
        <div *ngIf="errorMessage" class="text-center text_color_red error-message">
          {{ errorMessage }}
        </div>
        <mat-stepper labelPosition="bottom" linear="true" #stepper class="form-stepper bg-transparent">
          <!-- <mat-step [stepControl]="form" label="Personal Details"> -->
          <mat-step label="Step 1">  <!--[stepControl]="EmployeeProfileForm" -->
            <div class="mt-4">
              <h4 translate>1.1 Personal Details</h4>
            </div>
            <form (ngSubmit)="getfirtformdata()" [formGroup]="EmployeeProfileForm">
              <!-- <div class="row">
                
              </div> -->
              <div class="row">
                <div class="col-sm-8">
                  <div class="row">
                    <div class="col-12">
                      <div class="mb-3 col-12 col-sm-12 col-md-6 col-lg-6 col-xl-6 col-xxl-6">
                        <app-question [question]="EmployeeProfileFormQuestions[0]"
                          [form]="EmployeeProfileForm"></app-question>
                      </div>
                    </div>
                    <!-- <div class="mb-3 col-12 col-sm-12 col-md-6 col-lg-6 col-xl-6 col-xxl-6">
                      <app-question [question]="EmployeeProfileFormQuestions[0]"
                        [form]="EmployeeProfileForm"></app-question>
                    </div> -->
                    <div class="mb-3 col-12 col-sm-12 col-md-6 col-lg-6 col-xl-6 col-xxl-6">
                      <div class="d-flex">
                        <div class="col-4 me-2">
                          <app-question [question]="EmployeeProfileFormQuestions[1]"
                            [form]="EmployeeProfileForm"></app-question>
                        </div>
                        <div class="col-8">
                          <app-question [question]="EmployeeProfileFormQuestions[2]"
                            [form]="EmployeeProfileForm"></app-question>
                        </div>
                      </div>
                    </div>
                    <div class="mb-3 col-12 col-sm-12 col-md-6 col-lg-6 col-xl-6 col-xxl-6">
                      <app-question [question]="EmployeeProfileFormQuestions[3]"
                        [form]="EmployeeProfileForm"></app-question>
                    </div>
                    <div class="mb-3 col-12 col-sm-12 col-md-6 col-lg-6 col-xl-6 col-xxl-6">
                      <app-question [question]="EmployeeProfileFormQuestions[4]"
                        [form]="EmployeeProfileForm"></app-question>
                    </div>
                    <div class="mb-3 col-12 col-sm-12 col-md-6 col-lg-6 col-xl-6 col-xxl-6">
                      <app-question [question]="EmployeeProfileFormQuestions[5]"
                        [form]="EmployeeProfileForm"></app-question>
                    </div>
                  </div>
                </div>
                <div class="col-sm-4 d-flex align-items-center justify-content-center">
                  <div class="m-2">
                    <input #csvInput hidden="true" type="file" onclick="this.value=null"
                      (change)="imageInputChange($event)" accept="image/png, image/jpeg" />
                    <div>
                      <img *ngIf="!selectedImageUrl; else showImage" src="../../../assets/icons/Upload photo icon.svg"
                        aria-hidden="false" (click)="csvInput.click()"
                        style="cursor: pointer; width: 200px; height: 200px;" />
                      <ng-template #showImage>
                        <img [src]="selectedImageUrl" alt="Selected Image" (click)="csvInput.click()"
                          style="width: 200px; height: 200px; cursor: pointer;" />
                      </ng-template>
                      <p translate class="text-center mt-1">Upload Your Photo</p>
                    </div>
                    <p *ngIf="fileName" class="text-center mt-1">Selected file: {{ fileName }}</p>
                  </div>
                </div>
                <div *ngFor="let question of filterdata"
                  class="mb-3 col-12 col-sm-12 col-md-6 col-lg-6 col-xl-4 col-xxl-4">
                  <app-question [question]="question" [form]="EmployeeProfileForm"></app-question>
                </div>
              </div>
              <!-- <div>
                <button type="submit">getdata</button>
              </div> -->
            </form>
            <hr />
            <div>
              <!-- <div>
                <h4>Present Address</h4>
              </div> -->
              <form [formGroup]="EmployeePresentAddressForm">
                <div class="row">
                  <div *ngFor="let question of EmployeeAddressFormQuestions"
                    class="mb-3 col-12 col-sm-12 col-md-6 col-lg-6 col-xl-4 col-xxl-4">
                    <app-question [question]="question" [form]="EmployeePresentAddressForm"></app-question>
                  </div>
                </div>
              </form>
            </div>
            <div>
              <mat-checkbox class="mb-3" [(ngModel)]="checked" [(indeterminate)]="indeterminate"
                (click)="addresscheckbox()" [disabled]="!EmployeePresentAddressForm.valid">
                <span translate>Permanent Address is same as Present Address</span>
              </mat-checkbox>
            </div>
            <!-- <div>
              <form [formGroup]="EmployeeeAddresscheckboxForm">
                <div class="row">
                  <div *ngFor="let question of EmployeeeAddresscheckboxQuestions; let i=index"
                    class="mb-3 col-12 col-sm-12 col-md-6 col-lg-6 col-xl-4 col-xxl-4">
                    <app-question [question]="question"
                      [form]="EmployeeeAddresscheckboxForm"></app-question>
                  </div>
                </div>
              </form>
            </div> -->
            <div>
              <div>
                <h4 translate>Permanent Address</h4>
              </div>
              <form [formGroup]="EmployeePermanentAddressForm">
                <div class="row">
                  <div *ngFor="let question of EmployeeAddressFormQuestions; let i=index"
                    class="mb-3 col-12 col-sm-12 col-md-6 col-lg-6 col-xl-4 col-xxl-4">
                    <app-question [question]="changingids(question, i)"
                      [form]="EmployeePermanentAddressForm"></app-question>
                  </div>
                </div>
              </form>
            </div>
            <hr />
            <div>
              <div class="mb-2">
                <ng-container *ngIf="educationaddformarry.length > 0">
                  <div class="row">
                    <div class="mb-3 col-12 col-sm-12 col-md-6 col-lg-6 col-xl-4 col-xxl-4"
                      *ngFor="let arrayform of educationaddformarry; let i=index">
                      <!-- <ng-container *ngIf="arrayform.qualification_id !== null"> -->
                      <div class="card position-relative" *ngIf="arrayform.qualification_id !== null">
                        <div class="m-2 px-2">
                          <div><b>{{arrayform.qualification_name}}</b></div>
                          <div>{{arrayform.course_name}}</div>
                          <div class="mt-3">
                            <div translate>Year of passing : <span>{{arrayform.end_year | date: 'yyyy'}}</span> </div>
                            <div translate>Pass Percentage : <span>{{arrayform.percentage}}</span></div>
                          </div>
                        </div>
                        <!-- <div class="d-flex align-items-end">
                          <div><button mat-raised-button color="primary" class="mx-2"
                              (click)="editarrayform(arrayform)">edit</button></div>
                          <div><button mat-raised-button color="primary" (click)="deletearrayform(i)">delete</button>
                          </div>
                        </div> -->
                        <div class="position-absolute top-5 end-0">
                          <div class="action_button" [matMenuTriggerFor]="menu" aria-label="Actions">
                            <i class="fa-solid fa-ellipsis-vertical"></i>
                          </div>
                          <mat-menu #menu="matMenu">
                            <button mat-menu-item (click)="editarrayform(arrayform, i)">
                              <span translate>Edit</span>
                            </button>
                            <button mat-menu-item class="delete_button" (click)="deletearrayform(i)">
                              <span translate>Delete</span>
                            </button>
                          </mat-menu>
                        </div>
                      </div>
                      <!-- </ng-container> -->
                    </div>
                  </div>
                </ng-container>
              </div>
              <div>
                <form (ngSubmit)="arraySubmit()" [formGroup]="EmployeeEducationForm">
                  <div>
                    <h4 translate>1.2 Education Details</h4>
                  </div>
                  <div class="row">
                    <div *ngFor="let question of EmployeeEducationFormQuestions"
                      class="mb-3 col-12 col-sm-12 col-md-6 col-lg-6 col-xl-4 col-xxl-4">
                      <app-question [question]="question" [form]="EmployeeEducationForm"></app-question>
                    </div>
                  </div>
                  <div class="d-flex">
                    <button type="button" class="me-3 cancel_button" (click)="reseteducationform()"
                      mat-stroked-button><i class="fa-solid fa-xmark"></i> <span translate>Cancel</span></button>
                    <ng-container *ngIf="editeducationarrayflag">
                      <button type="submit" class="add_button" mat-raised-button color="primary" (click)="arraySubmit()"
                        [disabled]="!EmployeeEducationForm.valid"><i class="fa-solid fa-plus"></i> Add Details</button>
                    </ng-container>
                    <ng-container *ngIf="!editeducationarrayflag">
                      <button translate type="submit" class="update_button" mat-raised-button color="primary"
                        (click)="editarrySubmit()" [disabled]="!EmployeeEducationForm.valid">Update Details</button>
                    </ng-container>
                  </div>

                  <!-- add the submit button if the form is valid -->
                </form>
              </div>
            </div>
          </mat-step>
          <!-- <mat-step label="Address" [stepControl]="form1"> -->

          <!-- <mat-step label="Educational Details" [stepControl]="form2">
            <button (click)="addGroup()">Add</button>
            <form [formGroup]="educationaddform">
              <div  *ngFor="let educational_qualifications of this.fa?.value; let i = index">
              <div class="row" >
                <div *ngFor="let question of Vuequestions" class="col-sm-6">
                  <app-question
                    [question]="functionaddid(question, i)"
                    [form]="objectToFormGroup(educational_qualifications)"
                  ></app-question>
                </div>
              </div>
              </div>
              <div>
                <button (click)="getform3()"></button>
              </div>
            </form>
          </mat-step> -->
          <mat-step label="Step 2"> <!-- [stepControl]="EmployeeExperienceForm" -->
            <div class="mt-4">
              <div class="mb-2">
                <ng-container *ngIf="experienceaddformarry.length > 0">
                  <div class="row">
                    <div class="mb-3 col-12 col-sm-12 col-md-6 col-lg-6 col-xl-4 col-xxl-4"
                      *ngFor="let arrayform of experienceaddformarry; let i=index">
                      <!-- <ng-container *ngIf="arrayform.qualification_id !== null"> -->
                      <div class="card position-relative">
                        <div class="m-2 px-2">
                          <div><b>{{arrayform.designation}}</b></div>
                          <div>{{arrayform.organization_name}}</div>
                          <div>{{arrayform.location}}</div>
                          <div class="mt-3">
                            <div>Join Date : <span>{{arrayform.start_date | date}}</span> </div>
                            <div>Release Date : <span>{{arrayform.end_date | date}}</span></div>
                          </div>
                        </div>
                        <!-- <div class="d-flex align-items-end">
                          <div><button mat-raised-button color="primary" class="mx-2"
                              (click)="editarrayform(arrayform)">edit</button></div>
                          <div><button mat-raised-button color="primary" (click)="deletearrayform(i)">delete</button>
                          </div>
                        </div> -->
                        <div class="position-absolute top-5 end-0">
                          <div class="action_button" [matMenuTriggerFor]="menu" aria-label="Actions">
                            <i class="fa-solid fa-ellipsis-vertical"></i>
                          </div>
                          <mat-menu #menu="matMenu">
                            <p mat-menu-item class="m-0" (click)="editexperiencearrayform(arrayform, i)">
                              <span translate>Edit</span>
                            </p>
                            <p mat-menu-item class="m-0" (click)="deleteexperiencearrayform(i)">
                              <span translate>Delete</span>
                            </p>
                          </mat-menu>
                        </div>
                      </div>
                      <!-- </ng-container> -->
                    </div>
                  </div>
                </ng-container>
              </div>
              <div>
                <form (ngSubmit)="experiencearraySubmit()" [formGroup]="EmployeeExperienceForm">
                  <div>
                    <h4 translate>2.1 Experience Details</h4>
                  </div>
                  <div class="row">
                    <div *ngFor="let question of EmployeeExperienceFormQuestions"
                      class="mb-3 col-12 col-sm-12 col-md-6 col-lg-6 col-xl-4 col-xxl-4">
                      <app-question [question]="question" [form]="EmployeeExperienceForm"></app-question>
                    </div>
                  </div>
                  <div class="d-flex">
                    <button type="button" class="me-3 cancel_button" (click)="resetexperienceform()"
                      mat-stroked-button><i class="fa-solid fa-xmark"></i><span translate> Cancel </span></button>
                    <ng-container *ngIf="editexperiencearrayflag">
                      <button type="submit" class="add_button" mat-raised-button color="primary"
                        (click)="experiencearraySubmit()" [disabled]="!EmployeeExperienceForm.valid"><i
                          class="fa-solid fa-plus"></i><span translate> Add Details </span></button>
                    </ng-container>
                    <ng-container *ngIf="!editexperiencearrayflag">
                      <button type="submit" class="update_button" mat-raised-button color="primary"
                        (click)="editexperiencearrySubmit()" [disabled]="!EmployeeExperienceForm.valid"><span translate>Update
                        Details </span></button>
                    </ng-container>
                  </div>

                  <!-- add the submit button if the form is valid -->
                </form>
              </div>

              <!-- scholarly_work From Details start here -->

              <div class="mt-4 mb-2">
                <ng-container *ngIf="scholarly_workaddformarry.length > 0">
                  <div class="row">
                    <div class="mb-3 col-12 col-sm-12 col-md-6 col-lg-6 col-xl-4 col-xxl-4"
                      *ngFor="let arrayform of scholarly_workaddformarry; let i=index">
                      <!-- <ng-container *ngIf="arrayform.qualification_id !== null"> -->
                      <div class="card position-relative">
                        <div class="m-2 px-2">
                          <div><b>{{arrayform.title}}</b></div>
                          <div>{{getscholarly_work(arrayform.organization_name)}}</div>
                          <div>{{getactivitydata(arrayform.activity_type)}}</div>
                          <div>{{getplatformdata(arrayform.platform_id)}}</div>
                          <div>Release on <span>{{arrayform.year | date}}</span> </div>
                          <div>{{arrayform.description}}</div>
                        </div>
                        <!-- <div class="d-flex align-items-end">
                          <div><button mat-raised-button color="primary" class="mx-2"
                              (click)="editarrayform(arrayform)">edit</button></div>
                          <div><button mat-raised-button color="primary" (click)="deletearrayform(i)">delete</button>
                          </div>
                        </div> -->
                        <div class="position-absolute top-5 end-0">
                          <div class="action_button" [matMenuTriggerFor]="menu" aria-label="Actions">
                            <i class="fa-solid fa-ellipsis-vertical"></i>
                          </div>
                          <mat-menu #menu="matMenu">
                            <p mat-menu-item class="m-0" (click)="editscholarly_workarrayform(arrayform, i)">
                              <span translate>Edit</span>
                            </p>
                            <p mat-menu-item class="m-0" (click)="deletescholarly_workarrayform(i)">
                              <span translate>Delete</span>
                            </p>
                          </mat-menu>
                        </div>
                      </div>
                      <!-- </ng-container> -->
                    </div>
                  </div>
                </ng-container>
              </div>
              <div class="mt-4">
                <form (ngSubmit)="scholarly_workarraySubmit()" [formGroup]="EmployeeScholarly_workForm">
                  <div>
                    <h4 translate>2.2 Achievements Publications & Journal </h4>
                  </div>
                  <div class="row">
                    <div *ngFor="let question of EmployeeScholarly_workFormQuestions"
                      class="mb-3 col-12 col-sm-12 col-md-6 col-lg-6 col-xl-4 col-xxl-4">
                      <app-question [question]="question" [form]="EmployeeScholarly_workForm"></app-question>
                    </div>
                  </div>
                  <div class="d-flex">
                    <button type="button" class="me-3 cancel_button" (click)="resetscholarly_workform()"
                      mat-stroked-button><i class="fa-solid fa-xmark"></i> Cancel</button>
                    <ng-container *ngIf="editscholarly_workarrayflag">
                      <button type="submit" class="add_button" mat-raised-button color="primary"
                        (click)="scholarly_workarraySubmit()" [disabled]="!EmployeeScholarly_workForm.valid"><i
                          class="fa-solid fa-plus"></i><span translate> Add Details </span></button>
                    </ng-container>
                    <ng-container *ngIf="!editscholarly_workarrayflag">
                      <button type="submit" class="update_button" mat-raised-button color="primary"
                        (click)="editscholarly_workarrySubmit()" [disabled]="!EmployeeScholarly_workForm.valid"><span translate>Update
                        Details</span></button>
                    </ng-container>
                  </div>

                  <!-- add the submit button if the form is valid -->
                </form>
              </div>
            </div>
          </mat-step>
          <mat-step label="Step 3" [stepControl]="EmployeeJoiningForm && EmployeeSalaryForm">
            <div>
              <div class="mt-4">
                <h4 translate>3.1 Joining</h4>
              </div>
              <div>
                <form [formGroup]="EmployeeJoiningForm">
                  <div class="row">
                    <div *ngFor="let question of EmployeeJoiningFormQuestions"
                      class="mb-3 col-12 col-sm-12 col-md-6 col-lg-6 col-xl-4 col-xxl-4">
                      <app-question [question]="question" [form]="EmployeeJoiningForm"></app-question>
                    </div>
                  </div>
                </form>
              </div>
            </div>
            <hr />
            <div>
              <div>
                <h4 translate>3.2 Salary</h4>
              </div>
              <div>
                <form [formGroup]="EmployeeSalaryForm">
                  <div class="row">
                    <div *ngFor="let question of EmployeeSalaryFormQuestions"
                      class="mb-3 col-12 col-sm-12 col-md-6 col-lg-6 col-xl-4 col-xxl-4">
                      <app-question [question]="question" [form]="EmployeeSalaryForm"></app-question>
                    </div>
                  </div>
                </form>
              </div>
            </div>
            <hr />
            <div>
              <div>
                <h4 translate>3.3 Bank Details</h4>
              </div>
              <div>
                <form [formGroup]="EmployeeBankdetailsForm">
                  <div class="row">
                    <div *ngFor="let question of EmployeeBankdetailsFormQuestions"
                      class="mb-3 col-12 col-sm-12 col-md-6 col-lg-6 col-xl-4 col-xxl-4">
                      <app-question [question]="question" [form]="EmployeeBankdetailsForm"></app-question>
                    </div>
                  </div>
                </form>
              </div>
            </div>
          </mat-step>
        </mat-stepper>
      </div>
      <div class="form-row d-flex justify-content-end my-3 py-2 bg-white">
        <button mat-stroked-button color="primary" class="px-5 mx-2 cancel_button" (click)="stepper.previous()"
          [disabled]="stepper.selectedIndex === 0">
         <span translate> Back </span>
        </button>
        <button mat-raised-button color="primary" class="px-5 mx-2 submit_button"
          *ngIf="stepper.selectedIndex === stepper.steps.length - 1 && EmployeePresentAddressForm.valid && EmployeePermanentAddressForm.valid"
          [disabled]="!EmployeeJoiningForm.valid" (click)="onSubmit()">
          {{ isEditMode ? 'Update' : 'Submit' }}
        </button>
        <!-- <button mat-raised-button color="primary" class="px-5"
          *ngIf="stepper.selectedIndex !== stepper.steps.length - 1" (click)="onSubmit()" [disabled]="!EmployeeProfileForm.valid">
          Save
        </button> -->
        <button mat-raised-button class="px-5 mx-2 submit_button"
          *ngIf="stepper.selectedIndex !== stepper.steps.length - 1" (click)="stepper.next()">
           <span translate>Save And Continue</span>
        </button>
      </div>

      <!-- <div *ngIf="payLoad" class="form-row">
      <strong>Saved the following values</strong><br>{{payLoad}}
    </div> -->
    </div>
  </ng-container>
  <div *ngIf="showuploadconfirm">
    <div class="modal fade" tabindex="-1" aria-labelledby="exampleModalLabel" aria-hidden="true">
      <div class="modal-dialog">
        <div class="modal-content">
          <div class="modal-header">
            <h5 translate class="modal-title" id="exampleModalLabel">Upload Employee Data</h5>
            <button type="button" class="btn-close cancel_button" data-bs-dismiss="modal" aria-label="Close"></button>
          </div>
          <div class="modal-body">
            ...
          </div>
          <div class="modal-footer">
            <button translate type="button" class="btn btn-secondary cancel_button" data-bs-dismiss="modal">Close</button>
            <button translate type="button" class="btn btn-primary submit_button">Save changes</button>
          </div>
        </div>
      </div>
    </div>
  </div>
</section>